module.exports = __webpack_public_path__ + "img/title02_solgan.0679adad.png";